import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonItemDivider, IonLabel, IonList, IonListHeader, IonModal, IonSegment, IonSegmentButton, IonSelect, IonSelectOption, IonTextarea, IonTitle, IonToolbar } from "@ionic/react"
import { add, arrowBack, remove } from "ionicons/icons"
import moment from "moment"
import React, { FormEvent } from "react"
import IAlarma from "../interfaces/IAlarma"
import IAlimento from "../interfaces/IAlimento"
import ICaloriasDia from "../interfaces/ICaloriasDia"
import IDatosIniciales from "../interfaces/IDatosIniciales"
import { post } from "../Rest"
import BuscadorProductos from "./BuscadorProductos"
import db from "./Database"
import { horarios_comida, IHorarioComida, updateAlarma } from "./Funciones"

export default class AgregarAlimentos extends React.Component<{isOpen:boolean,fecha:string,horario?:IHorarioComida,onSave:any,onClose:any,alimento?:IAlimento}>{

    state = {
        cur_item:{
          cantidad:"1",
        } as ICaloriasDia,
        datos_iniciales:{} as IDatosIniciales,
        alarmas:{} as IAlarma,
        alimento:undefined as IAlimento | undefined,
        tipo:"B"
    }

    async componentDidMount(){
        const datos_iniciales = await db.datos_iniciales.toArray()
        const alarmas = await db.alarmas.toArray()
        await this.setState({datos_iniciales:datos_iniciales[0],alarmas:alarmas[0]})
    }

    verifyHorario = () => {
        const {cur_item} = this.state
        const {alimento} = this.props
        if(this.props.horario){
            cur_item.horario_comida = this.props.horario?.name
        }else{
            cur_item.horario_comida = this.getHorarioComida()
        }
        if(alimento){
            cur_item.detalle = alimento.nombre
            cur_item.calorias = alimento.calorias
            cur_item.cantidad = "1"
            cur_item.alimento = alimento.id
        }
        this.setState({cur_item,alimento})
    }

    plus = () => {
        const {cur_item} = this.state
        const alimento = this.props.alimento?this.props.alimento:this.state.alimento
        cur_item.cantidad = (parseFloat(cur_item.cantidad)>1000?1000:parseFloat(cur_item.cantidad)+1).toFixed(0)
        if(alimento){
            cur_item.calorias = (parseFloat(alimento.calorias)*parseFloat(cur_item.cantidad)).toFixed(0)
        }
        this.setState({cur_item})
    }

    minus = () =>{
        const {cur_item} = this.state
        const alimento = this.props.alimento?this.props.alimento:this.state.alimento
        cur_item.cantidad = (parseFloat(cur_item.cantidad)<=0?1:parseFloat(cur_item.cantidad)-1).toFixed(0)
        if(alimento){
            cur_item.calorias = (parseFloat(alimento.calorias)*parseFloat(cur_item.cantidad)).toFixed(0)
        }
        this.setState({cur_item})
    }

    sync = async () => {
        const {datos_iniciales} = this.state
        if(datos_iniciales && datos_iniciales.id && navigator.onLine){
            const items = await db.calorias_dia.filter(f => !f.id).toArray()
            const items_del = await db.calorias_dia.filter(f => parseInt(f.id)==-1).toArray()
            const response_items = await post("sync_calorias_dia/"+datos_iniciales.id,{items,items_del})
            await db.calorias_dia.clear()
            await db.calorias_dia.bulkPut(response_items)
        }
    }

    save = async (e:FormEvent)=> {
        e.preventDefault()
        const {cur_item,datos_iniciales} = this.state
        const {onSave,fecha} = this.props
        const alimento = this.props.alimento?this.props.alimento:this.state.alimento
        if(!cur_item.horario_comida){
            cur_item.horario_comida = this.getHorarioComida()
        }
        cur_item.fecha = moment(fecha).format("YYYY-MM-DD")
        cur_item.fecha_registro = moment().format("YYYY-MM-DD HH:mm:ss")
        cur_item.datos_iniciales_id = datos_iniciales.id
        if(alimento && alimento.id){
        cur_item.calorias = (parseFloat(alimento.calorias)*parseFloat(cur_item.cantidad)).toFixed(0)
        cur_item.alimento = alimento.id
        cur_item.detalle = alimento.porcion+" de "+alimento.nombre
        }
        await db.calorias_dia.put(cur_item)
        await this.setState({cur_item:{cantidad:"1"},alimento:{}})
        await this.sync()
        await updateAlarma()
        onSave(cur_item)
    }

    setCurItem = (e:any) => {
        var {cur_item} = this.state
        const alimento = this.props.alimento?this.props.alimento:this.state.alimento
        cur_item = {...cur_item,[e.target.name]:e.detail.value} 
        if(alimento){
            cur_item.calorias = (parseFloat(alimento.calorias)*parseFloat(cur_item.cantidad)).toFixed(0)
        }
        this.setState({cur_item})
    }

    getHorarioComida = () => {
        const {alarmas} = this.state
        const {horario} = this.props
        if(horario && horario.name){
            return horario.name
        }
        var horario_comida = "Cena"
        const cur_date = moment()
        if(cur_date.isBefore(moment(cur_date.format("YYYY-MM-DD")+" "+alarmas.media_manana))){
            horario_comida = "Desayuno"
        }
        else if(cur_date.isBefore(moment(cur_date.format("YYYY-MM-DD")+" "+alarmas.almuerzo))){
            horario_comida = "Media mañana"
        }
        else if(cur_date.isBefore(moment(cur_date.format("YYYY-MM-DD")+" "+alarmas.media_tarde))){
            horario_comida = "Almuerzo"
        }
        else if(cur_date.isBefore(moment(cur_date.format("YYYY-MM-DD")+" "+alarmas.cena))){
            horario_comida = "Media tarde"
        }
        return horario_comida
    }

    onAddAlimento = async (alimento:IAlimento) => {
        const {cur_item} = this.state
        cur_item.alimento = alimento.id
        cur_item.calorias = alimento.calorias
        cur_item.detalle = alimento.porcion+" de "+alimento.nombre
        cur_item.cantidad = "1"
        await this.setState({cur_item,alimento})
    }

    onDeleteAlimento = async () => {
        await this.setState({cur_item:{calorias:0,cantidad:1},alimento:null})
    }

    onChangeTipo = (e:any) => {
        const {cur_item} = this.state
        if(e.detail.value === "P"){
            cur_item.alimento = ""
            this.setState({tipo:e.detail.value,alimento:undefined})
        }else{
            cur_item.detalle = ""
            this.setState({tipo:e.detail.value,cur_item})
        }
    }

    render(){
        const {cur_item,tipo} = this.state
        const {alimento,isOpen,onClose} = this.props
        return (
            <IonModal isOpen={isOpen} onDidDismiss={onClose} onWillPresent={this.verifyHorario}>
                <IonHeader mode="md">
                    <IonToolbar>
                        <IonButtons slot="start">
                            <IonButton onClick={onClose}><IonIcon icon={arrowBack} /></IonButton>
                        </IonButtons>
                        <IonTitle>
                            Agregar alimento
                        </IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent>
                    <form onSubmit={this.save}>
                        <IonList>
                            <IonListHeader>Alimento:</IonListHeader>
                            {
                                !alimento && (
                                    <IonItem lines="none">
                                        <IonSegment mode="ios" value={tipo} onIonChange={this.onChangeTipo}>
                                            <IonSegmentButton value="B">Buscar</IonSegmentButton>
                                            <IonSegmentButton value="P">Personalizar</IonSegmentButton>
                                        </IonSegment>
                                    </IonItem>
                                )
                            }
                            {
                                alimento ? (
                                    <IonItem>
                                        <h4><small>{alimento.porcion}</small><br/>{alimento.nombre}</h4>
                                    </IonItem>
                                ):(
                                    tipo === "B" ?
                                    <BuscadorProductos onAdd={this.onAddAlimento} />
                                    :
                                    <IonItem>
                                        <IonTextarea value={cur_item.detalle} rows={3} placeholder="Describe tu alimento" name="detalle" onIonChange={this.setCurItem} required />
                                    </IonItem>

                                )
                            }
                            <IonItemDivider></IonItemDivider>
                            <IonItem>
                                <IonButtons slot="start">
                                    <IonButton onClick={this.minus} disabled={parseFloat(cur_item.cantidad)<=1}><IonIcon icon={remove} /></IonButton>
                                </IonButtons>
                                <IonButtons slot="end">
                                    <IonButton onClick={this.plus} disabled={parseFloat(cur_item.cantidad)>=100}><IonIcon icon={add} /></IonButton>
                                </IonButtons>
                                <IonLabel>Cantidad:</IonLabel>
                                <IonInput className="ion-text-center" type="number" step="0.1" max="100" min="0" value={cur_item.cantidad} name="cantidad" onIonChange={this.setCurItem} placeholder="Cantidad" required />
                            </IonItem>
                            <IonItem>
                                <IonLabel>Calorías:</IonLabel>
                                <IonInput className="ion-text-right" type="number" step="1" max="10000" min="0" value={cur_item.calorias} name="calorias" onIonChange={this.setCurItem} placeholder="Calorías" required />
                            </IonItem>
                            <IonItem>
                                <IonLabel>Horario:</IonLabel>
                                <IonSelect value={cur_item.horario_comida} name="horario_comida" onIonChange={this.setCurItem} placeholder="Selecciona un horario">
                                    {
                                        horarios_comida.map((horario,i) =>(
                                            <IonSelectOption key={i}>{horario.name}</IonSelectOption>
                                        ))
                                    }
                                </IonSelect>
                            </IonItem>
                            <IonButton expand="block" type="submit">Agregar</IonButton>
                        </IonList>
                    </form>
                </IonContent>
            </IonModal>
        )
    }
}
